export interface IMessageGroup {
  id?: number;
  rentBeforeDay?: number;
  exceedRentDay?: number;
  contractExpired?: number;
}

export const defaultValue: Readonly<IMessageGroup> = {};
